export const ESPN_HERO_BUNDESLIGA_PLAYER_IMAGES: Record<string, Record<string, string[]>> = {
  augsburg: {
    'essende-samuel': ['essende-samuel-001.png', 'essende-samuel-002.png'],
    'fabian-rieder': ['fabian-rieder-001.png', 'fabian-rieder-002.png'],
    'han-noah-massengo': ['han-noah-massengo-001.png', 'han-noah-massengo-002.png'],
    'michael-gregoritsch': ['michael-gregoritsch-001.png', 'michael-gregoritsch-002.png'],
    'phillip-tietz': ['phillip-tietz-001.png', 'phillip-tietz-002.png']
  },
  bayern: {
    'harry-kane': ['harry-kane-001.png', 'harry-kane-002.png'],
    'joshua-kimmich': ['joshua-kimmich-001.png', 'joshua-kimmich-002.png'],
    'luis-diaz': ['luis-diaz-001.png', 'luis-diaz-002.png']
  },
  bremen: {
    'julian-malatini': ['julian-malatini-001.png', 'julian-malatini-002.png'],
    'marco-grull': ['marco-grull-001.png', 'marco-grull-002.png'],
    'marvin-ducksch': ['marvin-ducksch-001.png'],
    'romano-schmid': ['romano-schmid-001.png', 'romano-schmid-002.png']
  },
  dortmund: {
    'jobe-bellingham': ['jobe-bellingham-001.png', 'jobe-bellingham-002.png'],
    'julian-brandt': ['julian-brandt-001.png', 'julian-brandt-002.png'],
    'karim-adeyemi': ['karim-adeyemi-001.png', 'karim-adeyemi-002.png'],
    'marcel-sabitzer': ['marcel-sabitzer-001.png', 'marcel-sabitzer-002.png']
  },
  frankfurt: {
    'ansgar-knauff': ['ansgar-knauff-001.png', 'ansgar-knauff-002.png'],
    'can-uzun': ['can-uzun-001.png', 'can-uzun-002.png'],
    'mahmoud-dahoud': ['mahmoud-dahoud-001.png', 'mahmoud-dahoud-002.png'],
    'mario-gotze': ['mario-gotze-001.png', 'mario-gotze-002.png'],
    'michy-batshuayi': ['michy-batshuayi-001.png', 'michy-batshuayi-002.png'],
    'ritsu-doan': ['ritsu-doan-001.png', 'ritsu-doan-002.png']
  },
  freiburg: {
    'derry-scherhant': ['derry-scherhant-001.png', 'derry-scherhant-002.png'],
    'johan-manzambi': ['johan-manzambi-001.png', 'johan-manzambi-002.png'],
    'lucas-holer': ['lucas-holer-001.png', 'lucas-holer-002.png'],
    'niklas-beste': ['niklas-beste-001.png', 'niklas-beste-002.png'],
    'philipp-treu': ['philipp-treu-001.png', 'philipp-treu-002.png']
  },
  gladbach: {
    'joe-scally': ['joe-scally-001.png', 'joe-scally-002.png', 'joe-scally-003.png', 'joe-scally-004.png'],
    'nico-elvedi': ['nico-elvedi-001.png', 'nico-elvedi-002.png'],
    'rocco-reitz': ['rocco-reitz-001.png', 'rocco-reitz-002.png']
  },
  hamburg: {
    'nicolas-capaldo': ['nicolas-capaldo-001.png', 'nicolas-capaldo-002.png'],
    'rayan-philippe': ['rayan-philippe-001.png', 'rayan-philippe-002.png'],
    'yussuf-poulsen': ['yussuf-poulsen-001.png', 'yussuf-poulsen-002.png']
  },
  heidenheim: {
    'benedikt-gimber': ['benedikt-gimber-001.png', 'benedikt-gimber-002.png'],
    'marvin-pieringer': ['marvin-pieringer-001.png', 'marvin-pieringer-002.png'],
    'niklas-dorsch': ['niklas-dorsch-001.png', 'niklas-dorsch-002.png']
  },
  hoffenheim: {
    'bazoumana-toure': ['bazoumana-toure-001.png', 'bazoumana-toure-002.png'],
    'fisnik-asllani': ['fisnik-asllani-001.png', 'fisnik-asllani-002.png']
  },
  koln: {
    'eric-martel': ['eric-martel-001.png', 'eric-martel-002.png'],
    'florian-kainz': ['florian-kainz-001.png', 'florian-kainz-002.png'],
    'isak-johannesson': ['isak-johannesson-001.png', 'isak-johannesson-002.png']
  },
  leipzig: {
    'johan-bakayoko': ['johan-bakayoko-001.png', 'johan-bakayoko-002.png'],
    'willi-orban': ['willi-orban-001.png', 'willi-orban-002.png']
  },
  leverkusen: {
    'alejandro-grimaldo': ['alejandro-grimaldo-001.png', 'alejandro-grimaldo-002.png'],
    'exequiel-palacios': ['exequiel-palacios-001.png', 'exequiel-palacios-002.png'],
    'ezequiel-fernandez': ['ezequiel-fernandez-001.png', 'ezequiel-fernandez-002.png'],
    'patrik-schick': ['patrik-schick-001.png']
  },
  mainz: {
    'armindo-sieb': ['armindo-sieb-001.png', 'armindo-sieb-002.png', 'armindo-sieb-003.png'],
    'jae-sung-lee': [
      'jae-sung-lee-001.png',
      'jae-sung-lee-002.png',
      'jae-sung-lee-003.png',
      'jae-sung-lee-004.png',
      'jae-sung-lee-005.png'
    ],
    'nadiem-amiri': ['nadiem-amiri-001.png', 'nadiem-amiri-002.png']
  },
  'st-pauli': {
    'andreas-hountondji': ['andreas-hountondji-001.png', 'andreas-hountondji-002.png'],
    'danel-sinani': ['danel-sinani-001.png', 'danel-sinani-002.png'],
    'joel-chima-fujita': ['joel-chima-fujita-001.png', 'joel-chima-fujita-002.png'],
    'mathias-pereira-lage': ['mathias-pereira-lage-001.png', 'mathias-pereira-lage-002.png']
  },
  stuttgart: {
    'angelo-stiller': ['angelo-stiller-001.png', 'angelo-stiller-002.png'],
    'deniz-undav': ['deniz-undav-001.png', 'deniz-undav-002.png'],
    'ermedin-demirovic': [
      'ermedin-demirovic-001.png',
      'ermedin-demirovic-002.png',
      'ermedin-demirovic-003.png',
      'ermedin-demirovic-004.png',
      'ermedin-demirovic-005.png'
    ]
  },
  'union-berlin': {
    'ilyas-ansah': ['ilyas-ansah-001.png', 'ilyas-ansah-002.png'],
    'tom-rothe': ['tom-rothe-001.png', 'tom-rothe-002.png']
  },
  wolfsburg: {
    'christian-eriksen': ['christian-eriksen-001.png', 'christian-eriksen-002.png'],
    'maximilian-arnold': ['maximilian-arnold-001.png', 'maximilian-arnold-002.png']
  }
};
